export default function getAbsoluteUrlForMedia(media, mediaHost = process.env.NEXT_PUBLIC_HOST): string {
  if (!media) {
    return '';
  }

  const pathname = `/api/download/${media.id}/${media.name}?hash=${media.hash}`;
  return `${mediaHost || ''}${pathname}`;
}
